enum EApiMonitoring {
  shipmentTracker = '/externals/trackers/shipments',
  getVesselTracker = '/externals/trackers/vessels',
  getVesselTrackerDetail = '/externals/trackers/vessels/:id',
}

export default EApiMonitoring;
